export default {
  CATEGORY: 'CATEGORY',
  QUESTION: 'QUESTION'
}
